// extracted by mini-css-extract-plugin
export default {"list":"list_list__24Vmu","item":"list_item__z7MVH","no-result":"list_no-result__V2yFC","item__icon":"list_item__icon__e6eLa"};